'use strict';

export var httpService = function($http, $state, configService, loggingService) {

    var send = (config) => {

        return $http(config)
            .then(res => {
                return res.data;
            }).catch(ex => {
                loggingService.error(ex, config);

                $state.go('error', {myErrorMessage: ex.data.error});
            });
    }

    var sendToApi = (config, pathSegment) => {
        return configService.getAppSettings().then(settings => {
            config.url = `${settings.apiUrl}${pathSegment}`;
            return send(config);
        });
    }

    var sendWithoutErrorHandling = (config) => {
        return $http(config)
            .then(res => {
                return res.data;
        });
    }

    var service = {
        send: send,
        sendToApi: sendToApi,
        sendWithoutErrorHandling: sendWithoutErrorHandling
    };

    return service;
};

httpService.$inject = ['$http', '$state', 'configService', 'loggingService'];